import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
// @ts-ignore
import loading from '../../../assets/images/loading.gif';
import { connect } from '../redux';
function Loading(props) {
    const reduxData = useSelector((state) => state['features/base/loading']);
    // isLoad(직접 제어 모드): load prop 미전달 호출처(루트 Suspense fallback 등)에서
    // load 가 undefined → null 렌더(빈 화면)가 되던 버그 수정 — 기본값 true.
    // (load={false} 를 명시 전달하는 호출처는 기존대로 숨김 유지)
    const data = props.isLoad ? { load: props.load ?? true, option: props.option } : reduxData;
    const { load, option } = useMemo(() => data, [data]);
    if (!load)
        return null;
    return (React.createElement("div", { className: "load_cover center nonSelect", style: {
            background: `${option ? 'rgba(0,0,0, 0.8)' : 'rgba(0,0,0, 0.5)'}`,
            display: 'block',
            zIndex: 9999,
            left: '50%',
            width: '100%',
            height: '100%',
        } },
        React.createElement("div", { className: "load center nonSelect" },
            React.createElement("dl", { style: {
                    background: `url(${loading}) no-repeat`,
                    width: '65px',
                    height: '65px',
                } }),
            React.createElement("span", { className: "text overText" }, option || 'LOADING'))));
}
export default connect()(Loading);
